export class Snippet {
  public scenario_id: number;
  public user_id: number;
  public title: string;
  public type: string;
  public snippet_json: string;
  public created: string;
  public modified: string;

  constructor(
    scenario_id: number,
    user_id: number,
    title: string,
    type: string,
    snippet_json: string,
    created: string,
    modified: string,
  ) {
    this.scenario_id = scenario_id;
    this.user_id = user_id;
    this.title = title;
    this.type = type;
    this.snippet_json = snippet_json;
    this.created = created;
    this.modified = modified;
  }
}
